module.exports = __webpack_public_path__ + "img/disperse-icon-04.50f88ec6.png";